import { render } from "./StrokedCopyIcon.vue?vue&type=template&id=4db32e84"
import script from "./StrokedCopyIcon.vue?vue&type=script&lang=js"
export * from "./StrokedCopyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__